import { BuyPrice } from '@buy/state/price'

export const priceInitialData: BuyPrice = {
    USD: {
        monthly: {
            tier1: {
                min: 0,
                price: 0,
                max: 0,
                monthlyUnitPrice: 0,
            },
            tier2: {
                min: 0,
                price: 0,
                max: 0,
                monthlyUnitPrice: 0,
            },
            tier3: {
                min: 0,
                price: 0,
                max: 0,
                monthlyUnitPrice: 0,
            },
        },
        annual: {
            tier1: {
                min: 0,
                price: 0,
                max: 0,
                monthlyUnitPrice: 0,
            },
            tier2: {
                min: 0,
                price: 0,
                max: 0,
                monthlyUnitPrice: 0,
            },
            tier3: {
                min: 0,
                price: 0,
                max: 0,
                monthlyUnitPrice: 0,
            },
        },
        monthlyAnnual: {
            tier1: {
                min: 0,
                price: 0,
                max: 0,
                monthlyUnitPrice: 0,
            },
            tier2: {
                min: 0,
                price: 0,
                max: 0,
                monthlyUnitPrice: 0,
            },
            tier3: {
                min: 0,
                price: 0,
                max: 0,
                monthlyUnitPrice: 0,
            },
        },
    },
}
